module.exports = __webpack_public_path__ + "img/Ruecken_Outline.fc4994f.svg";